<app-sidenav-filters
  [isOpen]="isSidenavOpen"
  (toggleSidenav)="toggleSidenav($event)"
  (torn)="changeTorn($event)"
  (unknown)="changeUnknown($event)"
  (site)="siteRequest($event)"
  (filter)="updateFilter($event)"
  (colorStatus)="changeColorStatus($event)"
  (devices)="changeDevices($event)"
  (lastSites)="changeLastSites($event)"
  (incidents)="changeIncidents($event)"
  (containers)="changeContainers($event)"
  (statusDays)="changeStatusDays($event)"
  (addIncidentDevices)="changeIncidentDevices($event)"
  (confidenceRadius)="changeConfidenceRadius($event)"
  (devicesTypes)="changeDevicesTypes($event)"
  (containerCategory)="changeContainerCategory($event)"
  [filterTorn]="filterTorn"
  [filterUnknown]="filterUnknown"
  [filterDevices]="filterDevices"
  [filterLastSites]="filterLastSites"
  [filterIncidents]="filterIncidents"
  [filterContainers]="filterContainers"
  [filterStatusDays]="filterStatusDays"
  [filterConfidenceRadius]="filterConfidenceRadius"
  [filterDevicesTypes]="filterDevicesTypes"
  [filterContainerCategory]="filterContainerCategory"
  [filterStatus]="statusList"
></app-sidenav-filters>

<app-site-sidenav
  [isVisible]="siteLock && !showDetailMap && !loadingProgress"
  [datas]="zoomSiteDatas"
  [site]="site"
></app-site-sidenav>

@if (showCreateIncident) {
  <app-incident-sidenav
    (closed)="closeIncidentCreation()"
    (incidentCreated)="addIncidentList($event)"
    [devices]="listIncidentDevices"
  ></app-incident-sidenav>
}

<div class="content">
  @if (showDetailMap && currentState && mapReady) {
    <app-map-detail
      [(map)]="map"
      [(currentState)]="currentState"
      [(display)]="showDetailMap"
      [hidden]="!showDetailMap"
      (backToMap)="onDetailClosed()"
      (toList)="toList($event)"
      (refreshMap)="onMapChanged()"
      (navigateIncident)="onChangeTab($event)"
    ></app-map-detail>
  }

  @if (!showDetailMap && !currentState) {
    <app-header-map
      class="map-header"
      (toggleFilters)="toggleSidenav($event)"
      [isSidenavOpen]="isSidenavOpen"
      (torn)="changeTorn($event)"
      (unknown)="changeUnknown($event)"
      (site)="siteRequest($event)"
      (filter)="updateFilter($event)"
      (colorStatus)="changeColorStatus($event)"
      (devices)="changeDevices($event)"
      (lastSites)="changeLastSites($event)"
      (incidents)="changeIncidents($event)"
      (containers)="changeContainers($event)"
      (statusDays)="changeStatusDays($event)"
      (addIncidentDevices)="changeIncidentDevices($event)"
      (confidenceRadius)="changeConfidenceRadius($event)"
      (devicesTypes)="changeDevicesTypes($event)"
      [loadingProgress]="loadingProgress"
      [listSites]="listSites"
      [listIncidentDevices]="listIncidentDevices"
      [isEmptyIncidentDevice]="isEmptyIncidentDevice"
      [filterTorn]="filterTorn"
      [filterUnknown]="filterUnknown"
      [filterSite]="filterSiteCode"
      [filterDevices]="filterDevices"
      [filterLastSites]="filterLastSites"
      [filterIncidents]="filterIncidents"
      [filterContainers]="filterContainers"
      [filterStatusDays]="filterStatusDays"
      [filterConfidenceRadius]="filterConfidenceRadius"
      [filterDevicesTypes]="filterDevicesTypes"
      [filterContainerCategory]="filterContainerCategory"
    >
    </app-header-map>
  }

  <div
    class="map"
    leaflet
    [leafletOptions]="options"
    (leafletMapReady)="onMapReady($event)"
  ></div>
  @if (!isSocketConnected) {
    <div class="map-socket-warning">
      <mat-spinner [diameter]="24" class="map-socket-spinner"></mat-spinner>
      <span class="map-pulse-text">
        {{ "socket.reconnecting" | translate }}
      </span>
    </div>
  }
</div>
